const state = {
     siteConfig:'',
     caiList:JSON.parse(sessionStorage.getItem('ROOM_CAILIST')||'[]') || [],
     caiJson:{},
     roomConfig:JSON.parse(sessionStorage.getItem('ROOM_CONFIG')||'{}') || {},
     connecter:null
}

const mutations = {
     setSiteConfig(state, data) {
        state.siteConfig = data;
     },
     setCaiList(state, data) {
        data.sort((a, b) => b.room_status - a.room_status);
        let caijson = {};
        for (var i=0;i<data.length;i++) {
            caijson[data[i].id] = data[i];
        }
        state.caiList = data;
        state.caiJson = caijson;
		    sessionStorage.setItem('ROOM_CAILIST',JSON.stringify(data));
     },
     updateCaiList(state, updata) {
        let data = [...state.caiList];
        let caijson = {};
        for (var i=0;i<data.length;i++) {
            let newData = data[i];
            if(data[i].id==updata.cai_id){
               newData = Object.assign({}, newData, updata);
            }
            caijson[data[i].id] = newData;
            data[i] = newData;
        }
        data.sort((a, b) => b.room_status - a.room_status);
        state.caiList = data;
        state.caiJson = caijson;
		    sessionStorage.setItem('ROOM_CAILIST',JSON.stringify(data));
     },
     setRoomConfig(state, data) {
        state.roomConfig = data;
		    sessionStorage.setItem('ROOM_CONFIG',JSON.stringify(data));
     },
     setConnecter(state, data) {
        state.connecter = data;
     }
}

const actions = {

}

export default {
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js